import exerciseRecord from './exerciseRecord.js'
export default {
  exerciseRecord
}
